// @noflow
import './styles.css';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Icon from '~/core/icons';
import intlMessages from '../intl';
import * as React from 'react';
import { SCHEDULE } from '~/core/constants/icons/general';

type Props = {
    handleChange: boolean => ?{},
    isScheduled: boolean
};

const FrequencySelector = ({ handleChange = () => {}, isScheduled }: Props) => (
    <div className="frequency-selector">
        <div
            className={classnames('frequency-selector__always', {
                'frequency-selector__active': !isScheduled
            })}
            onClick={handleChange.bind(this, false)}
        >
            <FormattedMessage {...intlMessages.always} />
        </div>
        <div
            className={classnames('frequency-selector__scheduled', {
                'frequency-selector__active': isScheduled
            })}
            onClick={handleChange.bind(this, true)}
        >
            <Icon className="frequency-selector__scheduled-icon" icon={SCHEDULE} />
            <FormattedMessage {...intlMessages.scheduled} />
        </div>
    </div>
);

export default FrequencySelector;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/frequency-selector/index.js